<article class="flex flex-col justify-start items-start p-5">
  @if (address().organisation) {
    <span>{{ address().organisation }}</span>
  }
  @if (address().street) {
    <span>{{ address().street }}</span>
  }
  @if (address().zipCode) {
    <span>{{ address().zipCode }}, {{ address().city }}</span>
  }
  @if (address().email) {
    <span>{{ address().email }}</span>
  }
  @if (address().web) {
    <span>{{ address().web }}</span>
  }
</article>
